export const NAV = {
  CAMPAIGN_HEADER_NAV: {
    DASHBOARD: 'dashboard',
    METRICS_BREAKDOWN: 'metrics-breakdown',
    CITY_PLANS: 'city-plans',
    MASTER_SCHEDULE: 'master-schedule',
    MANAGE_PAID_AMOUNTS: 'manage-paid-amounts',
    BONUS_RESULTS: 'bonus-results',
    CLIENT_QUESTIONS: 'client-questions',
    LIVE_MAP: 'live-map',
    UPLOAD_CODES: 'codes',
    INTERNAL_FILES: 'internal-files',
    CONVERSIONS: 'conversions',
    LOGS: 'logs',
    CODE_MANAGEMENT: 'code-management',
    MAILING_LIST: 'mailing-list',
    DETAILED_TRACKING: 'detailed-tracking',
  },
  CITY_HEADER_NAV: {
    AMBASSADORS: 'ambassadors',
    AMBASSADOR: 'ambassador',
    INVENTORY: 'inventory',
    LOCATIONS: 'locations',
    MASTER_SCHEDULE: 'global-planning',
    LIVE_MAP: 'live-map',
    PICKUP: 'pickup/all',
    STATS: 'stats',
    MANAGE_PAID_AMOUNTS: 'manage-paid-amounts',
    MANAGE_PICKUP_TIMES: 'manage-pickup-times',
    SPY: 'spy',
    DISTRIBUTION_ZONES: 'distribution-zones',
  },
  COUNTRY_HEADER_NAV: {
    SETTINGS: 'settings',
    PIPELINE: 'pipeline',
    GLOBAL_PLANING: 'global-planing',
    CHANNELS: 'channels',
    WEATHER: 'weather',
    PROJECT_MANAGEMENT: 'project-management',
    BA_PAYSLIP: 'ba-payslip',
    INVOICES: 'invoices',
  },
}
